<form [formGroup]="form" class="additional-services-step">
  <p class="additional-services-intro">{{ introText }}</p>

  <section class="additional-services-group">
    <h3>{{ groupCommunityHeading }}</h3>
    <p class="additional-services-group-prompt">{{ groupCommunityPrompt }}</p>

    <app-quantity-stepper
      [control]="form.controls.communityVisitsQty"
      [label]="communityVisitsLabel"
      [max]="8"
    />
    <app-text-input
      [control]="form.controls.communityVisitsGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('communityVisitsGuidance')"
      [required]="isGuidanceRequired('communityVisitsGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
    <app-quantity-stepper
      [control]="form.controls.travelQty"
      [label]="travelLabel"
    />

    <p class="additional-services-warning-banner" *ngIf="showTravelWarning">
      {{ travelWarningMessage }}
    </p>
  </section>

  <section class="additional-services-group">
    <h3>{{ groupTeamHeading }}</h3>

    <app-quantity-stepper
      [control]="form.controls.collaborativeCareCfssQty"
      [label]="collaborativeCareCfssLabel"
    />
    <app-text-input
      [control]="form.controls.collaborativeCareCfssGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('collaborativeCareCfssGuidance')"
      [required]="isGuidanceRequired('collaborativeCareCfssGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
    <app-quantity-stepper
      [control]="form.controls.collaborativeCareAudQty"
      [label]="collaborativeCareAudLabel"
    />
    <app-text-input
      [control]="form.controls.collaborativeCareAudGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('collaborativeCareAudGuidance')"
      [required]="isGuidanceRequired('collaborativeCareAudGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
  </section>

  <section class="additional-services-group">
    <h3>{{ groupSpeechHeading }}</h3>

    <app-quantity-stepper
      [control]="form.controls.additionalCommunicationAssessmentQty"
      [label]="additionalCommunicationAssessmentLabel"
    />
    <app-text-input
      [control]="form.controls.additionalCommunicationAssessmentGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="
        guidanceControlId('additionalCommunicationAssessmentGuidance')
      "
      [required]="
        isGuidanceRequired('additionalCommunicationAssessmentGuidance')
      "
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
    <app-toggle-button
      [control]="form.controls.startingSchoolReport"
      [label]="startingSchoolReportLabel"
    />
    <app-text-input
      [control]="form.controls.startingSchoolReportGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('startingSchoolReportGuidance')"
      [required]="isGuidanceRequired('startingSchoolReportGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
    <app-toggle-button
      [control]="form.controls.socialEmotionalAssess"
      [label]="socialEmotionalAssessLabel"
    />
    <app-text-input
      [control]="form.controls.socialEmotionalAssessGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('socialEmotionalAssessGuidance')"
      [required]="isGuidanceRequired('socialEmotionalAssessGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
  </section>

  <section class="additional-services-group">
    <h3>{{ groupHearingHeading }}</h3>
    <p class="additional-services-group-prompt">{{ groupHearingPrompt }}</p>

    <app-toggle-button
      [control]="form.controls.annualSpeechPerception"
      [label]="annualSpeechPerceptionLabel"
    />
    <p class="additional-services-hint">{{ annualSpeechPerceptionHint }}</p>
    <app-text-input
      [control]="form.controls.annualSpeechPerceptionGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('annualSpeechPerceptionGuidance')"
      [required]="isGuidanceRequired('annualSpeechPerceptionGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
    <app-toggle-button
      [control]="form.controls.speechPerceptionTesting"
      [label]="speechPerceptionTestingLabel"
    />
    <app-text-input
      [control]="form.controls.speechPerceptionTestingGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('speechPerceptionTestingGuidance')"
      [required]="isGuidanceRequired('speechPerceptionTestingGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />

    <app-textarea
      *ngIf="requiresAnnualSpeechPerceptionReason"
      [control]="form.controls.annualSpeechPerceptionReason"
      [label]="annualSpeechPerceptionReasonLabel"
      [required]="requiresAnnualSpeechPerceptionReason"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.ANNUAL_SPEECH_PERCEPTION_REASON_REQUIRED'
          | translate
      "
    />
  </section>

  <section class="additional-services-group">
    <h3>{{ groupGroupsHeading }}</h3>

    <app-toggle-button
      [control]="form.controls.talkTogether"
      [label]="talkTogetherLabel"
    />
    <app-text-input
      [control]="form.controls.talkTogetherGuidance"
      [label]="bookingGuidanceLabel"
      [controlId]="guidanceControlId('talkTogetherGuidance')"
      [required]="isGuidanceRequired('talkTogetherGuidance')"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.BOOKING_GUIDANCE_REQUIRED' | translate
      "
    />
  </section>
</form>
